export default __webpack_public_path__ + "static/media/vision.bdc041d8.jpg";